(function (window) {
  'use strict';
  if (window.LFMobileFramePlayer) return;

  var CACHE_LIMIT = 32;
  var CONCURRENT_LIMIT = 6;
  var AHEAD_FRAMES = 12;
  var BEHIND_FRAMES = 4;
  var STALL_MS = 8000;

  function clamp(value, min, max) { return Math.max(min, Math.min(max, value)); }
  function now() { return window.performance && window.performance.now ? window.performance.now() : Date.now(); }
  function key(scene, index) { return scene + ':' + index; }
  function padded(index) { return ('0000' + (index + 1)).slice(-4); }

  function Player(sticky, scenes, onReady, onError, onPresented) {
    this.sticky = sticky;
    this.phoneTransition = window.innerWidth <= 767;
    this.rawIndex = 0;
    this.blendFrom = null;
    this.presentedPosition = null;
    if (this.phoneTransition && sticky) sticky.setAttribute('data-lf-ending-transition', 'scrub');
    this.scenes = (scenes || []).map(function (scene) {
      return {
        template: String(scene.mobileTemplate || ''), count: Math.floor(Number(scene.mobileFrameCount)),
        endingStart: typeof scene.mobileEndingStartFrame === 'number' ? scene.mobileEndingStartFrame : -1,
        endingImage: String(scene.mobileEndingImage || '')
      };
    });
    this.onReady = onReady;
    this.onError = onError;
    this.onPresented = onPresented;
    this.slots = Object.create(null);
    this.inFlight = 0;
    this.clock = 0;
    this.target = {scene: 0, index: 0};
    this.direction = 1;
    this.visible = null;
    this.shown = false;
    this.destroyed = false;
    this.failed = false;
    this.blockedSince = null;
    this.deadlineTimer = null;
    this.presentRaf = null;
    this.valid = !!sticky && this.scenes.length > 0 && this.scenes.every(function (scene) {
      return scene.template.indexOf('{index}') !== -1 && isFinite(scene.count) && scene.count >= 2 && scene.count <= 9999;
    });
    if (!this.valid) {
      var self = this;
      this.deadlineTimer = window.setTimeout(function () { self.fail('frame-config-error'); }, 0);
      return;
    }
    this.updateDeadline(false);
    this.pump();
  }

  Player.prototype.setProgress = function (sceneIndex, local) {
    if (this.destroyed || !this.valid) return;
    sceneIndex = clamp(Math.floor(Number(sceneIndex) || 0), 0, this.scenes.length - 1);
    local = clamp(Number(local) || 0, 0, 1);
    var position = local * (this.scenes[sceneIndex].count - 1);
    var index = this.resourceIndex(sceneIndex, Math.round(position));
    var unchanged = sceneIndex === this.target.scene && index === this.target.index;
    this.rawIndex = position;
    if (sceneIndex !== this.target.scene) this.direction = sceneIndex > this.target.scene ? 1 : -1;
    else if (index !== this.target.index) this.direction = index > this.target.index ? 1 : -1;
    this.target = {scene: sceneIndex, index: index};
    // Sub-frame scroll updates need no queue rebuild outside the ending blend.
    if (unchanged && !this.isEndingTarget()) return;
    this.maybePresent();
    if (this.destroyed) return;
    this.updateDeadline(false);
    this.pump();
  };

  Player.prototype.resourceIndex = function (sceneIndex, index) {
    var scene = this.scenes[sceneIndex];
    return this.phoneTransition && scene.endingImage && scene.endingStart >= 0 && index >= scene.endingStart ? scene.endingStart : index;
  };

  Player.prototype.isEndingTarget = function () {
    var scene = this.scenes[this.target.scene];
    return this.phoneTransition && scene.endingImage && scene.endingStart >= 0 && this.target.index >= scene.endingStart;
  };

  // This queue is rebuilt from the latest target, never from obsolete scroll events.
  Player.prototype.wanted = function () {
    var scene = this.target.scene, index = this.target.index, count = this.scenes[scene].count;
    var list = [], seen = Object.create(null), self = this;
    function add(s, i) {
      i = self.resourceIndex(s, i);
      var id = key(s, i);
      if (seen[id]) return;
      seen[id] = true;
      list.push({scene: s, index: i, key: id});
    }
    function neighbor(offset) {
      var s = scene, i = index + offset;
      while (i < 0 && s > 0) { s--; i += this.scenes[s].count; }
      while (s < this.scenes.length - 1 && i >= this.scenes[s].count) { i -= this.scenes[s].count; s++; }
      if (i >= 0 && i < this.scenes[s].count) add(s, i);
    }
    add(scene, index);
    if (this.isEndingTarget()) add(scene, this.scenes[scene].endingStart - 1);
    var ahead = this.phoneTransition && this.scenes[scene].endingStart >= 0 ? 18 : AHEAD_FRAMES;
    for (var distance = 1; distance <= ahead; distance++) {
      neighbor.call(this, distance * this.direction);
      if (distance <= BEHIND_FRAMES) neighbor.call(this, -distance * this.direction);
    }
    // Prepare the single ending resource during the washing scene.
    if (this.phoneTransition && this.scenes[scene].endingStart >= 0 && this.scenes[scene].endingImage) add(scene, this.scenes[scene].endingStart);
    return list;
  };

  Player.prototype.pump = function () {
    if (this.destroyed) return;
    var queue = this.wanted(), wanted = Object.create(null), self = this;
    queue.forEach(function (request) { wanted[request.key] = true; });
    // A large jump must not wait behind obsolete in-flight requests.
    Object.keys(this.slots).forEach(function (id) {
      var slot = self.slots[id];
      if (slot.status === 'loading' && !wanted[id] &&
          (slot.scene !== self.target.scene || Math.abs(slot.index - self.target.index) > AHEAD_FRAMES * 2)) {
        self.inFlight--;
        self.release(slot);
      }
    });
    for (var i = 0; i < queue.length && this.inFlight < CONCURRENT_LIMIT; i++) {
      if (!this.slots[queue[i].key]) this.load(queue[i]);
    }
    this.evict();
  };

  Player.prototype.load = function (request) {
    var self = this, image = new window.Image();
    var slot = {key: request.key, scene: request.scene, index: request.index, image: image, status: 'loading', touched: ++this.clock};
    this.slots[slot.key] = slot;
    this.inFlight++;
    var scene = this.scenes[slot.scene];
    var isEnding = scene.endingStart >= 0 && slot.index >= scene.endingStart && !!scene.endingImage;
    image.className = 'lf-sequence__video lf-sequence__frame' + (isEnding ? ' is-ending-frame' : '');
    image.decoding = 'async';
    image.alt = '';
    image.setAttribute('data-scene', String(slot.scene));
    image.setAttribute('aria-hidden', 'true');
    image.style.opacity = '0';
    image.style.zIndex = '3';
    if (slot.key === key(this.target.scene, this.target.index)) image.setAttribute('fetchpriority', 'high');
    function settle(ok) {
      if (self.destroyed || self.slots[slot.key] !== slot || slot.status !== 'loading') return;
      image.onload = null;
      image.onerror = null;
      self.inFlight--;
      slot.status = ok && image.naturalWidth > 0 && image.naturalHeight > 0 ? 'decoded' : 'error';
      slot.touched = ++self.clock;
      if (slot.status === 'error') {
        image.removeAttribute('src');
        slot.image = null;
      }
      self.schedulePresent();
      if (self.destroyed) return;
      self.updateDeadline(false);
      self.pump();
    }
    image.onload = function () {
      if (self.destroyed || slot.status !== 'loading') return;
      if (typeof image.decode !== 'function') { settle(true); return; }
      // onload alone is not acceptance: a rejected or pending decode stays hidden.
      try { image.decode().then(function () { settle(true); }, function () { settle(false); }); }
      catch (error) { settle(false); }
    };
    image.onerror = function () { settle(false); };
    // The retired tail must never be a loading/error fallback. The replacement
    // is accepted through the same decode gate as every other displayed frame.
    try { image.src = isEnding ? scene.endingImage : scene.template.split('{index}').join(padded(slot.index)); }
    catch (error) { settle(false); }
  };

  Player.prototype.schedulePresent = function () {
    if (this.destroyed || this.presentRaf !== null) return;
    var self = this;
    this.presentRaf = window.requestAnimationFrame(function () {
      self.presentRaf = null;
      self.maybePresent();
    });
  };

  Player.prototype.maybePresent = function () {
    if (this.destroyed) return false;
    if (this.isEndingTarget()) return this.presentEnding();
    var target = this.target, current = this.visible, best = null, distance = Infinity;
    var exact = this.slots[key(target.scene, target.index)];
    if (exact && exact.status === 'decoded') best = exact;
    else {
      // Only a nearby frame moving toward the latest target can replace the image.
      // Late requests behind the displayed frame cannot rewind a forward scroll.
      var ids = Object.keys(this.slots);
      for (var i = 0; i < ids.length; i++) {
        var slot = this.slots[ids[i]];
        if (slot.status !== 'decoded' || slot.scene !== target.scene) continue;
        var gap = Math.abs(slot.index - target.index);
        if (gap > AHEAD_FRAMES || gap >= distance) continue;
        if (this.direction >= 0 ? slot.index > target.index : slot.index < target.index) continue;
        if (current && current.scene === target.scene) {
          var from = current.index, to = target.index;
          if (slot.index === from || (slot.index - from) * (to - from) <= 0) continue;
          if (slot.index < Math.min(from, to) || slot.index > Math.max(from, to)) continue;
        }
        best = slot;
        distance = gap;
      }
    }
    if (!best || best === current) return false;
    if (this.blendFrom) {
      if (this.blendFrom !== best && this.blendFrom.image.parentNode === this.sticky) this.sticky.removeChild(this.blendFrom.image);
      this.blendFrom = null;
    }
    this.presentedPosition = null;
    if (this.phoneTransition) this.sticky.removeAttribute('data-lf-ending-mix');
    best.touched = ++this.clock;
    best.image.style.opacity = '1';
    this.sticky.appendChild(best.image);
    this.visible = best;
    if (current && current.image && current.image.parentNode === this.sticky) this.sticky.removeChild(current.image);
    this.updateDeadline(true);
    if (!this.shown) {
      this.shown = true;
      if (this.onReady) this.onReady();
    }
    if (this.destroyed || this.visible !== best || best.scene !== this.target.scene) return true;
    if (this.onPresented) this.onPresented(best.scene, best.index / (this.scenes[best.scene].count - 1));
    return true;
  };

  Player.prototype.presentEnding = function () {
    var sceneIndex = this.target.scene, scene = this.scenes[sceneIndex];
    var ending = this.slots[key(sceneIndex, scene.endingStart)];
    var wash = this.slots[key(sceneIndex, scene.endingStart - 1)];
    // Never reveal an undecoded ending or the retired tail; keep the last good frame.
    if (!ending || ending.status !== 'decoded' || !wash || wash.status !== 'decoded') return false;
    var progress = clamp((this.rawIndex - scene.endingStart) / 12, 0, 1);
    var mix = progress * progress * (3 - 2 * progress);
    var current = this.visible;
    var changed = current !== ending || this.presentedPosition !== this.rawIndex;
    if (!changed) return false;
    wash.touched = ending.touched = ++this.clock;
    wash.image.style.opacity = (1 - mix).toFixed(4);
    ending.image.style.opacity = mix.toFixed(4);
    if (wash.image.parentNode !== this.sticky) this.sticky.appendChild(wash.image);
    if (ending.image.parentNode !== this.sticky) this.sticky.appendChild(ending.image);
    if (current && current !== wash && current !== ending && current.image.parentNode === this.sticky) this.sticky.removeChild(current.image);
    this.visible = ending;
    this.blendFrom = wash;
    this.presentedPosition = this.rawIndex;
    this.sticky.setAttribute('data-lf-ending-mix', mix.toFixed(4));
    this.updateDeadline(true);
    if (!this.shown) { this.shown = true; if (this.onReady) this.onReady(); }
    if (!this.destroyed && this.onPresented) this.onPresented(sceneIndex, this.rawIndex / (scene.count - 1));
    return true;
  };

  Player.prototype.updateDeadline = function (advanced) {
    if (this.destroyed) return;
    var settled = this.visible && this.visible.scene === this.target.scene && this.visible.index === this.target.index;
    if (settled) {
      this.blockedSince = null;
      if (this.deadlineTimer !== null) window.clearTimeout(this.deadlineTimer);
      this.deadlineTimer = null;
      return;
    }
    if (this.blockedSince === null || advanced) this.blockedSince = now();
    if (this.deadlineTimer !== null) {
      if (!advanced) return;
      window.clearTimeout(this.deadlineTimer);
    }
    var self = this;
    this.deadlineTimer = window.setTimeout(function () {
      self.deadlineTimer = null;
      if (self.destroyed) return;
      if (self.maybePresent()) return;
      // Progress updates cannot extend this deadline; only a new displayed frame can.
      if (self.blockedSince !== null && now() - self.blockedSince >= STALL_MS) self.fail('frame-load-timeout');
      else self.updateDeadline(false);
    }, Math.max(1, STALL_MS - (now() - this.blockedSince)));
  };

  Player.prototype.release = function (slot) {
    if (slot.image) {
      slot.image.onload = null;
      slot.image.onerror = null;
      if (slot.image.parentNode === this.sticky) this.sticky.removeChild(slot.image);
      slot.image.removeAttribute('src');
      slot.image = null;
    }
    delete this.slots[slot.key];
  };

  Player.prototype.evict = function () {
    var ids = Object.keys(this.slots);
    if (ids.length <= CACHE_LIMIT) return;
    var wanted = Object.create(null), queue = this.wanted(), candidates = [], self = this;
    for (var i = 0; i < queue.length; i++) wanted[queue[i].key] = true;
    ids.forEach(function (id) {
      var slot = self.slots[id];
      if (slot !== self.visible && slot !== self.blendFrom && slot.status !== 'loading' && !wanted[id]) candidates.push(slot);
    });
    candidates.sort(function (a, b) { return a.touched - b.touched; });
    for (var n = ids.length, j = 0; n > CACHE_LIMIT && j < candidates.length; n--, j++) this.release(candidates[j]);
  };

  Player.prototype.fail = function (reason) {
    if (this.destroyed || this.failed) return;
    this.failed = true;
    var notify = this.onError, target = this.target;
    this.destroy();
    if (notify) notify({reason: reason, sceneIndex: target.scene, frameIndex: target.index});
  };

  Player.prototype.destroy = function () {
    if (this.destroyed) return;
    this.destroyed = true;
    if (this.presentRaf !== null) window.cancelAnimationFrame(this.presentRaf);
    this.presentRaf = null;
    if (this.deadlineTimer !== null) window.clearTimeout(this.deadlineTimer);
    this.deadlineTimer = null;
    var self = this;
    Object.keys(this.slots).forEach(function (id) { self.release(self.slots[id]); });
    this.inFlight = 0;
    this.visible = null;
    this.blendFrom = null;
    if (this.phoneTransition && this.sticky) { this.sticky.removeAttribute('data-lf-ending-transition'); this.sticky.removeAttribute('data-lf-ending-mix'); }
    this.onReady = null;
    this.onError = null;
    this.onPresented = null;
    this.sticky = null;
  };

  window.LFMobileFramePlayer = Player;
})(window);
